import PropTypes from "prop-types"
import { useContext } from "react"
import { MultiContext } from "~/contexts/MultiContext"
import { SingleContextProvider } from "~/contexts/SingleContext"
import { Add, Frame, Placeholder, Video, YTLiveChat } from "~/components/Single"

Position.propTypes = {
  uuid: PropTypes.string.isRequired,
}
export function Position({ uuid }) {
  const { data, positions, focus } = useContext(MultiContext)
  const position = Number(Object.keys(positions).find((key) => positions[key] === uuid))
  const videoData = data.find((d) => d.uuid === uuid)

  if (!videoData) return <Add />

  const focused = position === focus

  return (
    <>
      <SingleContextProvider position={position} uuid={uuid} videoData={videoData}>
        <Frame position={position}>{videoData.chat ? <YTLiveChat /> : <Video />}</Frame>
      </SingleContextProvider>
      {focused && <Placeholder position={position} />}
    </>
  )
}
